import { useEffect } from 'react';
import { useVoltaAlert } from '@volta/context/Consumers';
import { useAxios2, usePrevious } from '@volta/utils/hooks';

const useUserApprovalCount = () => {
  const { openFailedAlert } = useVoltaAlert();

  const [apiFetch, isLoading, apiStatus, apiResponse] = useAxios2(
    'user/total-data-approval',
    'get',
    true
  );

  const prevStatus = usePrevious(apiStatus);

  const fetchData = () => {
    return apiFetch();
  };

  useEffect(() => {
    if (prevStatus !== undefined && prevStatus !== apiStatus) {
      if (apiStatus === 0 || (apiStatus === 1 && !apiResponse)) {
        openFailedAlert({
          description:
            'Terjadi kesalahan saat memuat data user approval, harap coba lagi.',
          textButtonFailed: 'Oke',
        });
      }
    }
  }, [apiStatus]);

  useEffect(() => {
    fetchData();
  }, []);

  const isDataLoaded = apiResponse;

  return {
    data: isDataLoaded ? apiResponse?.data?.total_data : [],
    isLoading,
    status: apiStatus,
    refetch: fetchData,
  };
};

export default useUserApprovalCount;
